import dynamic from "next/dynamic";

export const UploadFile = dynamic(() => import("./UploadFile"), {
  ssr: false
});
